import React from "react";
import "../../../dist/assets/stylesheets/css/notification.css";
import { Icon } from '@iconify/react';
import GlobalOverlayPortal from './GlobalOverlayPortal';

function ConfirmModal(props) {
  const isLoading = props.isLoading === true;
  const confirmLabel = props.confirmLabel != null ? props.confirmLabel : "Confirm";

  return (
    <GlobalOverlayPortal>
      <div className="modal-container">
        <div className="modal confirm">
          <Icon
            onClick={() => !isLoading && props.rejectHandler()}
            className="close-btn"
            icon="iconamoon:close"
            style={isLoading ? { pointerEvents: 'none', opacity: 0.5 } : undefined}
            aria-hidden={isLoading}
          />

          <div className="icon-info-container">
            <div className="icon-container">
              <Icon icon="clarity:warning-line" />
            </div>
            <div className="info-container">
              <h4>Confirmation</h4>
              <span>{props.message}</span>
            </div>
          </div>
          <div className="btn-container">
            <button
              id="cancel-btn"
              onClick={() => props.rejectHandler()}
              disabled={isLoading}
            >
              Cancel
            </button>
            <button
              id="confirm-btn"
              onClick={() => props.acceptHandler()}
              disabled={isLoading}
            >
              {isLoading ? (
                <>
                  <Icon icon="eos-icons:loading" className="confirm-loading-spinner" />
                  Deleting…
                </>
              ) : (
                confirmLabel
              )}
            </button>
          </div>
        </div>
      </div>
    </GlobalOverlayPortal>
  );
}

export default ConfirmModal;
